// src/components/ProjectManagement/KanbanColumn.jsx
import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import KanbanTask from './KanbanTask';

const KanbanColumn = ({ id, title, tasks, color, canEdit, currentUser, onTaskUpdate, onFilterByProject, projectProgressMap }) => {
  const { setNodeRef, isOver } = useDroppable({ id });

  const getColorStyles = () => {
    switch(color) {
      case 'blue': return { borderTop: '3px solid #3b82f6', icon: '⏳', bg: '#eff6ff' };
      case 'orange': return { borderTop: '3px solid #f59e0b', icon: '⚙️', bg: '#fffbeb' };
      case 'green': return { borderTop: '3px solid #10b981', icon: '✅', bg: '#ecfdf5' };
      case 'red': return { borderTop: '3px solid #ef4444', icon: '🔴', bg: '#fef2f2' };
      default: return { borderTop: '3px solid #6b7280', icon: '📋', bg: '#f9fafb' };
    }
  };

  const colorStyles = getColorStyles();

  return (
    <div className={`kanban-column ${isOver ? 'drag-over' : ''}`} style={{ background: colorStyles.bg }}>
      <div className="column-header" style={{ borderTop: colorStyles.borderTop }}>
        <div className="column-title">
          <span className="column-icon">{colorStyles.icon}</span>
          <h3>{title}</h3>
        </div>
        <span className="task-count-badge">{tasks.length}</span>
      </div>
      
      <div ref={setNodeRef} className="column-tasks">
        {tasks.map(task => (
          <KanbanTask 
            key={task.id} 
            task={task} 
            canEdit={canEdit}
            currentUser={currentUser}
            onTaskUpdate={onTaskUpdate}
            onFilterByProject={onFilterByProject}
            projectProgress={projectProgressMap?.[task.projectId]}
          />
        ))}
        
        {tasks.length === 0 && (
          <div className="empty-column">
            <div className="empty-icon">📭</div>
            <p>No {title.toLowerCase()} tasks</p>
            <small>Tasks will appear here</small>
          </div>
        )}
      </div>
    </div>
  );
};

export default KanbanColumn;